import React from 'react';

import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { DEFAULT_FEATURE_FLAG_TREATMENT_ENABLED_VALUE, type FeatureFlagName } from '#/shared/types/FeatureFlag';

type FeatureFlagProps = {
  name: FeatureFlagName;
  value?: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export const FeatureFlag = ({
  name,
  value = DEFAULT_FEATURE_FLAG_TREATMENT_ENABLED_VALUE,
  children,
  fallback = null,
}: FeatureFlagProps) => {
  const { getTreatmentWithConfig, isReady } = useFeatureFlag(name);

  if (!isReady) {
    return fallback;
  }

  const treatment = getTreatmentWithConfig();

  if (treatment.treatment === value) {
    return <>{children}</>;
  }

  return fallback;
};
